import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import authService, { socioLogin } from "../../services/authService";
import { useAuth } from "../../context/AuthContext";
import "../../styles/socioLoginModal.css";

const SocioLoginModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [email, setEmail] = useState("");
  const [codigoIngreso, setCodigoIngreso] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleClose = () => {
    if (loading) return;
    setError("");
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await socioLogin(email, codigoIngreso);
      const data = response.data || {};
      const access = data.access || data.tokens?.access;
      const refresh = data.refresh || data.tokens?.refresh;

      authService.persistSession({
        tokens: { access, refresh },
        user: data.user,
      });
      setSession(data.user);
      onClose();
      navigate("/dashboard");
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403 && err?.response?.data?.primer_acceso) {
        onClose();
        navigate("/primer-acceso", { state: { email } });
        return;
      }

      if (status === 400 || status === 401) {
        setError("Correo o código de ingreso incorrecto");
      } else if (status === 403) {
        setError("Tu cuenta no está activa. Contacta al administrador.");
      } else if (status === 429) {
        setError("Demasiados intentos. Espera un momento e intenta de nuevo.");
      } else {
        setError("Error inesperado. Intenta de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle className="socio-login-modal__title">
        Ingreso de Socios
      </DialogTitle>
      <form onSubmit={handleSubmit} className="socio-login-modal__form">
        <DialogContent className="socio-login-modal__content">
          <TextField
            label="Correo electrónico"
            type="email"
            fullWidth
            margin="normal"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            disabled={loading}
            autoComplete="email"
          />

          <TextField
            label="Código de Ingreso"
            type="password"
            fullWidth
            margin="normal"
            required
            value={codigoIngreso}
            onChange={(event) => setCodigoIngreso(event.target.value)}
            disabled={loading}
            autoComplete="current-password"
          />

          {error && (
            <Alert severity="error" className="socio-login-modal__alert">
              {error}
            </Alert>
          )}
        </DialogContent>

        <DialogActions className="socio-login-modal__actions">
          <Button onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            className="login-button socio-login-modal__submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress
                  size={20}
                  color="inherit"
                  className="socio-login-modal__spinner"
                />
                Iniciando sesión...
              </>
            ) : (
              "Ingresar"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SocioLoginModal;
